import { useEffect, useState } from "react";
import { fileUrl } from "../lib/files";

/**
 * Renders an image stored in Object Storage by its storage path.
 * Fetches it as a blob (supports auth in the future) and displays it.
 * Falls back to a plain <img src=url> when blob fetch fails.
 */
export default function AuthImage({ path, alt = "", className = "", fallback = null, style }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) return;
    let cancelled = false;
    let currentBlob = null;
    (async () => {
      try {
        const res = await fetch(fileUrl(path), { credentials: "include" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const blob = await res.blob();
        if (cancelled) return;
        currentBlob = URL.createObjectURL(blob);
        setBlobUrl(currentBlob);
      } catch {
        if (!cancelled) setFailed(true);
      }
    })();
    return () => {
      cancelled = true;
      if (currentBlob) URL.revokeObjectURL(currentBlob);
    };
  }, [path]);

  if (!path) return fallback;
  if (failed) return fallback || <div className="text-[11px] text-zinc-400 italic">(No se pudo cargar)</div>;
  if (!blobUrl) {
    return (
      <div
        className={`animate-pulse bg-zinc-100 rounded ${className}`}
        style={style}
      />
    );
  }
  return <img src={blobUrl} alt={alt} className={className} style={style} />;
}
